import "react-datetime/css/react-datetime.css";
import React, { Component } from "react";
import Sidebar from "./layouts/side_bar/Sidebar";
import NavBar from "../components/layouts/NavBar";
import Main from "../components/Main";
import {
  getLoginUser,
  getErrorMessage,
  handleLogin,
  remote_url,
  main_url,
  getLoginUserInfo,
} from "../utils/CommonFunction";
import Login from "./Login/Login";

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined,
      user_id: this.props.user_id,
      hrm_user_id: null,
      user_id_from_token: null,
      error: null,
    };
  }
  async componentDidMount() {
    let user = await getLoginUser(this.props.user_id);
    this.setState({
      user: user,
    });
  }

  handleLogin = async (employeeCode, password) => {
    try {
      const user = await handleLogin(employeeCode, password);
      if (!!user) {
        this.setState({
          user: user,
        });
      } else throw "Something went wrong!";
    } catch (err) {
      this.setState({
        error: getErrorMessage(err),
      });
    }
  };

  render() {
    if (this.state.user === undefined) {
      return "";
      // return (
      //   <div
      //     style={{
      //       display: "flex",
      //       flexDirection: "column",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100vh",
      //     }}
      //   >
      //     <img
      //       src="assets/img/business_logo.png"
      //       height="15%"
      //       alt="Alliance Business Logo"
      //     />
      //     <h1
      //       style={{
      //         marginTop: 35,
      //         color: "#BFBFBF",
      //       }}
      //     >
      //       Alliance HRM System
      //     </h1>
      //     <p
      //       style={{
      //         marginTop: 5,
      //         color: "#BFBFBF",
      //       }}
      //     >
      //       Loading Data...
      //     </p>
      //   </div>
      // );
    }

    if (this.state.user === null && !this.props.user_id) {
      return <Login onLogin={this.handleLogin} error={this.state.error} />;
    }

    return (
      <div>
        <Sidebar />
        <div id="page-wrapper" className="gray-bg dashbard-1 ownheight">
          <NavBar />
          <Main />
        </div>
      </div>
    );
  }
}
